<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>礼品{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="150px">
          <el-form-item label="参与等级范围">
            <el-form :inline="true">
              <el-form-item prop="min_level">
                <el-input v-model.number="formData.min_level" style="width: 200px" />
              </el-form-item>
              <el-form-item label="-" prop="max_level">
                <el-input v-model.number="formData.max_level" style="width: 200px" />
              </el-form-item>
            </el-form>
          </el-form-item>
          <el-form-item label="商品类型" prop="g_type">
            <el-select v-model.number="formData.g_type" placeholder="请选择" @change="gTypeChnage">
              <el-option v-for="item in shopType" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="商品ID" prop="gid">
            <el-input v-model.number="formData.gid" style="width: 400px" placeholder="商品ID" />
          </el-form-item>
          <el-form-item label="存在时间(小时)" prop="life_time">
            <el-input v-model.number="formData.life_time" style="width: 400px" placeholder="存在时间(小时)" />
          </el-form-item>
          <el-form-item label="价格(美元)" prop="price">
            <!--            <el-input v-model.number="formData.price" style="width: 400px;" placeholder="美元" />-->
            <el-select v-model="formData.price" style="width: 100px;" placeholder="请选择" @change="(v)=>{return priceChange(v)}">
              <el-option v-for="(item, index) in shopSku" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="库存" prop="sku">
            <el-input v-model="formData.sku" readonly style="width: 400px;" placeholder="库存" />
          </el-form-item>
          <el-form-item label="折扣" prop="discount">
            <el-input v-model.number="formData.discount" style="width: 400px;" placeholder="折扣" />
          </el-form-item>
          <el-form-item label="配图文件路径" prop="skin_dir">
            <el-input v-model="formData.skin_dir" style="width: 400px;" placeholder="配图文件路径" />
          </el-form-item>
          <el-form-item label="最多购买次数" prop="max">
            <el-input v-model.number="formData.max" style="width: 400px;" placeholder="最多购买次数" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model.number="formData.status" style="width: 400px" placeholder="请选择">
              <el-option v-for="(item, index) in statusType" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.g_type === 23" label="标签" prop="tag">
            <el-select v-model.number="formData.tag" style="width: 400px" placeholder="请选择">
              <el-option v-for="(item, index) in tagType" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="奖励" prop="rewards">
            <el-form :inline="true">
              <Reward :value="formData.prize_json" :drawer="false" />
            </el-form>
          </el-form-item>
          <el-form-item label="备注" prop="desc" style="width: 400px;">
            <el-input v-model="formData.desc" type="textarea" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { getShopCfgList, getShopType, getSku, updateShopCfg } from '@/api/config/shop-cfg'
import Reward from '@/components/Reward'

export default {
  name: 'ShopEdit',
  components: { Reward },
  data() {
    return {
      gtype: 0,
      shopSku: [],
      rewardType: [],
      statusType: [
        { label: '上架', value: 1 },
        { label: '下架', value: 0 }
      ],
      tagType: [
        { label: 'T1', value: 1 },
        { label: 'T2', value: 2 },
        { label: 'T3', value: 3 },
        { label: '兰博基尼礼包', value: 4 },
        { label: '森林礼包', value: 5 }
      ],
      shopType: [],
      users: [],
      loading: false,
      formData:
        {
          'id': 0,
          'gid': 0,
          'g_type': 109,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'max': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'tag': 0,
          'prize_json': [
            {
              propsId: 1,
              skin: 0,
              num: 0,
              rtype: 2
            }
          ]
        },
      rules: {
        gid: [
          { required: true, message: '请输入商品ID', trigger: 'blur' }
        ],
        min_level: [
          { required: true, message: '请输入最小等级', trigger: 'blur' }
        ],
        max_level: [
          { required: true, message: '请输入最大等级', trigger: 'blur' }
        ],
        life_time: [
          { required: true, message: '请输入存在时间', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        sku: [
          { required: true, message: '请输入库存', trigger: 'blur' }
        ],
        discount: [
          { required: true, message: '请输入折扣', trigger: 'blur' }
        ],
        skin_dir: [
          { required: true, message: '请输入配图文件路径', trigger: 'blur' }
        ],
        prize_json: [
          { type: 'array', required: true, message: '请输入奖励', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getShopSkuList()
    this.getShopTypes()
    const id = this.$route.query.id
    this.gtype = parseInt(this.$route.query.type)
    if (id > 0) {
      this.getTables(id)
    }
    if (this.gtype > 0) {
      this.formData.g_type = this.gtype
    }
    this.getRewardTypeData()
  },
  methods: {
    priceChange(v) {
      let sku = ''
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
      }

      this.formData.sku = sku
    },
    getShopSkuList(type = 3) {
      getSku({ type: type }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          for (const i in res.data) {
            const val = res.data[i]
            this.shopSku.push({ label: val.price, value: val.price, sku: val.sku })
          }
          if (this.formData.price > 0) {
            this.priceChange(this.formData.price)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(id) {
      getShopCfgList({ id: id }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0]
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.gid <= 0) {
            this.msgError('商品ID不能为0')
            return
          }
          if (this.formData.min_level > this.formData.max_level) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          if (this.formData.price === 0) {
            this.msgError('请选择价格')
            return
          }

          if (this.formData.g_type === 23) {
            if (this.formData.tag === 0) {
              this.msgError('请选择标签')
              return
            }
            if (this.formData.id <= 0) {
              this.formData.skin_dir = '[]'
            }
          }

          // this.formData.g_type = this.gtype
          const data = JSON.stringify([this.formData])
          updateShopCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              if (this.formData.g_type === 23) {
                this.$router.push({ path: '/config/rule-gift/index' })
              } else {
                this.$router.push({ path: '/config/shop/index' })
              }
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward() {
      this.formData.prize_json.push({ propsId: 1, skin: 0, num: 0, rtype: 2 })
    },
    removeReward(i) {
      this.formData.prize_json = this.formData.prize_json.filter((item, key) => {
        return i !== key
      })
    },
    getShopTypes() {
      getShopType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopType.push({ label: val, value: parseInt(i) })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    gTypeChnage(v) {
      const val = parseInt(v)
      let typ = 3
      switch (val) {
        case 1:
          typ = 1
          break
        case 2:
          typ = 2
          break
      }

      this.getShopSkuList(typ)
    }
  }
}
</script>

<style scoped>
</style>
